import { Country } from './CountriesAndLanguages';
import { WithCrud } from './WithCrud';

export const ServiceTypes = ['program', 'vod', 'svod', 'thirdParty'] as const;
export type ServiceType = (typeof ServiceTypes)[number];

export type Provider = WithCrud<{
  allActiveContentId: string;
  alwaysSubscribed: boolean;
  country: Country;
  cvpId: string;
  id: string;
  image: string;
  name: string;
  params: Record<string, string>;
  portalIds: string[];
  rowKey: string;
  type: ServiceType;
}>;

export const vodProviderIdentifier = 'Film_og_serier';
